import * as api from '@/utils/request.js'

// 专家列表
export function getExportList (params) {
  return api.get(`http://i.didaward.cn/prod-api/business/expert/listall`, params)
}

// 新闻列表
export function getNewsList (params) {
  // return api.get(`http://localhost:8084/business/news/listall`, params)
  return api.get(`https://xulumaterial.com/prod-api/business/news/listall`, params)
}

// 产品列表
export function getProductListAll (params) {
  // return api.get(`http://localhost:8084/business/product/productListAll`, params)
  return api.get(`https://xulumaterial.com/prod-api/business/product/productListAll`, params)
}

// 新闻详情
export function getNewsListDetails ({newsId}) {
  return api.get(`http://i.didaward.cn/prod-api/business/news/detail/${newsId}`)
}

// 获取作品列表;
export function getWorkList (data) {
  return api.get(`http://i.didaward.cn/prod-api/business/expert/listall`, data)
}

// 根据年份获取作品列表;
export function getWorkYearList (params) {
  return api.get(`http://i.didaward.cn/prod-api/business/work/listall`, params)
}



// WEBPACK FOOTER //
// ./src/api/api.js